import type { ReactNode } from 'react';

import './CountBadge.scss';

/** Пропсы pill-бейджа CountBadge. */
export interface CountBadgeProps {
  /** md — чип в заголовке блока; sm — компактный счётчик в тексте карточки. */
  size?: 'md' | 'sm';
  className?: string;
  children: ReactNode;
}

/**
 * Pill-бейдж на сером фоне: число позиций, «чипы» в заголовках блоков.
 * Выделено из мастера ШМ (tfw-flow-badge / tfw-choice-count) в коллекцию ui.
 */
const CountBadge = ({ size = 'md', className, children }: CountBadgeProps) => (
  <span className={ `count-badge count-badge-${ size }${ className ? ` ${ className }` : '' }` }>
    { children }
  </span>
);

export default CountBadge;
